var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 25.6667H29.0002M24.0002 20.6667L24.0002 30.6667M32.3335 39H15.6668C13.8259 39 12.3335 37.5076 12.3335 35.6667V12.3333C12.3335 10.4924 13.8259 9 15.6668 9H24.9765C25.4185 9 25.8424 9.17559 26.155 9.48816L35.1787 18.5118C35.4912 18.8244 35.6668 19.2483 35.6668 19.6904V35.6667C35.6668 37.5076 34.1744 39 32.3335 39Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddimage);
export default __webpack_public_path__ + "static/media/Add image.de70be19b06c917c362840033e79c4e1.svg";
export { ForwardRef as ReactComponent };